import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import getUserToken from '../helpers/tokenValidation';
import { alertActions } from './auth/alertSlice';

const backendURL = process.env.REACT_APP_API_URL;
// https://www.yuwathipathi.lk
// // https://www.yuwathipathi.lk

export const cartAction = createAsyncThunk(
  'bankDetails/upload',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`, // Add authorization token if needed
        },
      };

      const { data } = await axios.post(
        `${backendURL}/api/bankSlip`,
        arg,
        config
      );

      dispatch(
        alertActions.createAlert({
          message: 'Bank details uploaded successfully!',
          type: 'success',
        })
      );

      return data;
    } catch (error) {
      // Dispatch error alert
      dispatch(
        alertActions.createAlert({
          message: error.response ? error.response.data.message : error.message,
          type: 'warning',
        })
      );

      return rejectWithValue(error.response ? error.response.data.message : error.message);
    }
  }
);

export const updatePayment = createAsyncThunk(
  'bankDetails/BankSlip',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`, // Add authorization token if needed
        },
      };

      const { data } = await axios.post(
        `${backendURL}/api/updateBankSlip`,
        arg,
        config
      );

      dispatch(
        alertActions.createAlert({
          message: 'payment details uploaded successfully!',
          type: 'success',
        })
      );

      return data;
    } catch (error) {
      dispatch(
        alertActions.createAlert({
          message: error.response ? error.response.data.message : error.message,
          type: 'warning',
        })
      );

      return rejectWithValue(error.response ? error.response.data.message : error.message);
    }
  }
);


export const driveImageUpload = createAsyncThunk(
  'image/driveImage',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${getUserToken()}`,
        },
      };
      const { data } = await axios.post(
        `${backendURL}/api/driveImagesUpload`,
        arg,
        config
      )

      dispatch(
        alertActions.createAlert({
          message: 'Images uploaded successfully!',
          type: 'success',
        })
      );
      return data;
    }

    catch (err) {
      dispatch(
        alertActions.createAlert({
          message: err.response ? err.response.data.message : err.message,
          type: 'warning',
        })
      )
      return rejectWithValue(err.response ? err.response.data.message : err.message);

    }
  }
)

// New action for uploading profile images
export const uploadProfileImage = createAsyncThunk(
  'image/uploadProfileImage',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${getUserToken()}`,
        },
      };
      const { data } = await axios.post(
        `${backendURL}/api/uploadProfileImage`,
        arg,
        config
      )

      dispatch(
        alertActions.createAlert({
          message: 'Profile image uploaded successfully!',
          type: 'success',
        })
      );
      return data;
    }

    catch (err) {
      dispatch(
        alertActions.createAlert({
          message: err.response ? err.response.data.message : err.message,
          type: 'warning',
        })
      )
      return rejectWithValue(err.response ? err.response.data.message : err.message);

    }
  }
)

export const driveImageDownload = createAsyncThunk(
  'image/users',
  async (arg, { rejectWithValue, dispatch }) => {
    const folderId = arg;
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.get(`${backendURL}/api/driveImagesDownload/${folderId}`, config);
      // dispatch(
      //   alertActions.createAlert({
      //     message: 'drive images download successfully!',
      //     type: 'success',
      //   })
      // );
      return data;
    } catch (err) {
      // dispatch(
      //   alertActions.createAlert({
      //     message: err.response ? err.response.data.message : err.message,
      //     type: 'warning',
      //   })
      // );
      return rejectWithValue(err.response ? err.response.data.message : err.message);
    }
  }
);

export const imageURLDbUpload = createAsyncThunk(
  'imageUrl/upload',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        }
      }
      const { data } = await axios.post(`${backendURL}/api/imageURL`, arg, config);
      dispatch(
        alertActions.createAlert({
          message: 'drive images URL uploaded successfully!',
          type: 'success',
        })
      );
      return data;
    } catch (err) {
      dispatch(
        alertActions.createAlert({
          message: err.response ? err.response.data.message : err.message,
          type: 'warning',
        })
      );
      return rejectWithValue(err.response ? err.response.data.message : err.message);
    }
  }
)

export const getPaidList = createAsyncThunk(
  'cartDetail/getPaidList',
  async (arg, { dispatch, rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-type': 'application/json'
        }
      }
      const { data } = await axios.get(`${backendURL}/api/getPaidUsers?userId=${arg},`,
        config)
      return data;
    } catch (err) {
      // dispatch(
      //   alertActions.createAlert({
      //     message: err.response ? err.response.data.message : err.message,
      //     type: 'warning',
      //   })
      // );
      return rejectWithValue(err.response ? err.response.data : err);
    }

  }


)